import { render, staticRenderFns } from "./weiboHome.vue?vue&type=template&id=5004016c&scoped=true"
import script from "./weiboHome.vue?vue&type=script&lang=js"
export * from "./weiboHome.vue?vue&type=script&lang=js"
import style0 from "./weiboHome.vue?vue&type=style&index=0&id=5004016c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004016c",
  null
  
)

export default component.exports